
const BaseUrl = 'http://13.215.25.127:3000/api/';
const BaseAssetUrl = 'http://13.215.25.127:3000/'; 

// const BaseUrl = 'https://tugoapi.ezzysales.com/api/';
// const BaseAssetUrl = 'https://tugoapi.ezzysales.com/'; 


// const BaseUrl = 'https://testapi.ezzysales.com/api/';
// const BaseAssetUrl = 'https://testapi.ezzysales.com/'; 


// const BaseUrl = 'https://api.tugoonline.co.uk/api/';
// const BaseAssetUrl = 'https://api.tugoonline.co.uk/'; 




// const BaseUrl = 'http://localhost:3000/api/';
// const BaseAssetUrl = 'http://localhost:3000/';

  export {BaseUrl, BaseAssetUrl}  

